import { Component, Input, OnInit } from '@angular/core';
import { View, ViewTitleService } from '@ntap/core';

import { PrimeNGListToolBarComponent } from '@ntap/primeng';

export const P_TITLE = 'title';

@Component({
  selector: 'app-list-toolbar',
  templateUrl: './list-toolbar.component.html',
  styleUrls: ['./list-toolbar.component.scss'],
  providers: [ViewTitleService],
  inputs: ['showTitle']
})
export class ListToolBarComponent
  extends PrimeNGListToolBarComponent
  implements OnInit
{
  @Input()
  title = '';

  ngOnInit(): void {
    this.addSubscription(this.view$.subscribe((v) => this.setTitleFromView(v)));
  }

  private setTitleFromView(v: View) {
    this.title = v?.title ?? '';
  }
}
